export interface ResettableFilterApi {
  setFilterModel: (model: null) => void;
}

/** Clear user-applied AG Grid column filters without changing contextual filters. */
export function resetGridFilters(api: ResettableFilterApi): void {
  api.setFilterModel(null);
}
